'use client';

import { useTransactionContext } from '../contexts/transactions-context';
import { useAccount } from 'wagmi';
export default function useIsTransactionPending(transactionHash?: string): boolean {
    const { state } = useTransactionContext();
    const { chain } = useAccount();
    const chainId = chain?.id;

    const transactions = state[chainId ?? 0] || {};

    if (!transactionHash || !transactions[transactionHash]) return false;

    return !transactions[transactionHash].receipt;
}